import { registerPlugin } from '@capacitor/core';

export type HealthRecordType = 'Steps' | 'ExerciseSession' | 'Distance' | 'TotalCaloriesBurned' | 'ActiveCaloriesBurned' | 'HeartRate' | 'RestingHeartRate' | 'Vo2Max' | 'SleepSession' | 'Weight' | 'BodyFat' | 'Height' | 'OxygenSaturation' | 'RespiratoryRate' | 'Hydration' | 'Nutrition';

export const defaultHealthReadTypes: HealthRecordType[] = ['Steps', 'ExerciseSession', 'Distance', 'TotalCaloriesBurned', 'ActiveCaloriesBurned', 'HeartRate', 'RestingHeartRate', 'Vo2Max', 'SleepSession', 'Weight', 'BodyFat', 'Height', 'OxygenSaturation', 'RespiratoryRate'];

export interface BridgeHealthRecord {
  provider: 'health_connect';
  recordType: string;
  externalRecordId: string;
  clientRecordId: string | null;
  dataOriginPackage: string;
  recordStart: string;
  recordEnd: string;
  startOffsetMinutes: number | null;
  endOffsetMinutes: number | null;
  metric: string;
  value: number;
  unit: string;
  sourceCreatedAt: string | null;
  sourceUpdatedAt: string | null;
  metadata: Record<string, unknown>;
}

export interface HealthConnectPlugin {
  getAvailability(): Promise<{ status: 'available' | 'not_installed' | 'update_required' | 'unsupported' }>;
  getPermissions(options: { recordTypes: HealthRecordType[] }): Promise<{ granted: string[]; missing: string[] }>;
  requestPermissions(options: { recordTypes: HealthRecordType[]; writeTypes?: HealthRecordType[]; includeHistory: boolean; includeBackground: boolean }): Promise<{ granted: string[]; denied: string[] }>;
  openSettings(): Promise<void>;
  pauseSync(): Promise<void>;
  sync(options: { recordTypes: HealthRecordType[]; since?: string }): Promise<{ batches: Array<{ recordType: string; records: BridgeHealthRecord[]; deletedIds: string[]; token: string }>; sourcePackages: string[] }>;
  getChanges(options: { recordType: HealthRecordType; token: string }): Promise<{ records: BridgeHealthRecord[]; token: string; hasMore: boolean; deletedIds: string[] }>;
  commitChanges(options: { recordType: HealthRecordType; token: string }): Promise<void>;
  getSources(options: { recordTypes: HealthRecordType[] }): Promise<{ sources: Array<{ packageName: string; appName?: string }> }>;
  writeWorkout(options: { startTime: string; endTime: string; kind: 'strength' | 'kickboxing' | 'walk' | 'mobility'; title: string; clientRecordId: string }): Promise<{ recordId: string }>;
  writeWeight(options: { time: string; weightKg: number; clientRecordId: string }): Promise<{ recordId: string }>;
  writeNutrition(options: { startTime: string; endTime: string; name: string; caloriesKcal: number; proteinG: number; carbohydrateG: number; fatG: number; fibreG: number; clientRecordId: string }): Promise<{ recordId: string }>;
}

export const HealthConnect = registerPlugin<HealthConnectPlugin>('HealthConnect');
